import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Auth from "./modules/AuthModule"
import Common from "./modules/CommonModule"
import Event from "./modules/EventModule"
import Patient from "./modules/PatientModule"
import Police from "./modules/PoliceModule"
import Circumstances from "./modules/CircumstancesModule"
import Deathreason from "./modules/DeathreasonModule"
import Injury from "./modules/InjuryModule"
import Hospital from "./modules/HospitalModule"

Vue.use(Vuex);

const modules = {
    Auth: Auth,
    Common: Common,
    Event: Event,
    Patient: Patient,
    Police: Police,
    Circumstances: Circumstances,
    Deathreason : Deathreason,
    Injury : Injury,
    Hospital : Hospital
};

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState()]
});
